module.exports = __webpack_public_path__ + "static/media/Profile_3.f88cf800.svg";